import React, { useState } from 'react';
import { UseFormRegister } from 'react-hook-form';

import IInputs from '../../../interfaces/IInputs';
import IRules from '../../../interfaces/IRules';
import './Select.sass';

import TooltipIcon from '../TooltipIcon';
import Tooltip from '../Tooltip';

interface Props {
	inputName:
		| 'city'
		| 'skills'
		| 'expertiseLevel'
		| 'talkFormat'
		| 'talkFormat2'
		| 'talkFormat3'
		| 'talkLanguage'
		| 'talkLanguage2'
		| 'talkLanguage3'
		| 'talkTrack'
		| 'talkTrack2'
		| 'talkAudienceLevel'
		| 'talkAudienceLevel2';
	hasTooltip?: string;
	content?: any;
	label: string;
	required?: boolean;
	register: UseFormRegister<IInputs>;
	rules: IRules;
	multiple?: boolean;
	placeholder?: string;
	options: [];
}

function Select({
	hasTooltip,
	content,
	label,
	required,
	register,
	inputName,
	rules,
	multiple,
	placeholder,
	options,
}: Props) {
	const [active, setActive] = useState<boolean>(false);

	return (
		<div className="select-row">
			<label htmlFor={inputName} className="form-label">
				{label} {required && '*'}
				{hasTooltip && hasTooltip !== '' && (
					<TooltipIcon
						tooltipValue={hasTooltip}
						setActive={setActive}
						active={active}
					/>
				)}
			</label>
			<select
				multiple={multiple}
				id={inputName}
				className="select-default"
				{...register(inputName, rules)}
			>
				<option value="">{placeholder || ''}</option>
				{options.length > 0 &&
					options.map((option, i) => (
						// eslint-disable-next-line react/no-array-index-key
						<option key={i} value={option}>
							{option}
						</option>
					))}
			</select>

			<Tooltip
				id="talkLanguage"
				arrowPlacement="top-right"
				content={content}
				active={active}
			/>
		</div>
	);
}

Select.defaultProps = {
	hasTooltip: false,
	required: false,
	multiple: false,
	placeholder: '',
};

export default Select;
